<template>
    <div class="rest_list_container">
        <div v-if="!showRestHeader" class="rest_list__header_container">
            <div class="rest_list__search">
                <search_block
                    :key="'search_block_'"
                    :placeholderText="placeholderTextSearch"
                    @search_input_data="searchInputData"
                />
            </div>
        </div>
        <div v-if="showRestHeader" class="rest_list__header">
            <div class="rest_list__header_container">
                <rest_list_header_item
                    v-for="item in headerList"
                    :key="'rest_list_header_item_' + item.id"
                    :item="item"
                    :operationName="operationName"
                    @select_item_header="selectItemHeader"
                />
            </div>
        </div>
    </div>
    <div v-if="showRestHeader" class="rest_list__search">
        <search_block
            :key="'search_block_'"
            :placeholderText="placeholderTextSearch"
            @search_input_data="searchInputData"
        />
        <button class="rest_list__search_filter" @click.prevent="clickFilter">
            <svg width="24" height="24"
                 class="rest_list__search_filter_icon">
                <use xlink:href="/icons/base.svg#filter"></use>
            </svg>
        </button>
    </div>

    <div class="rest_list__scroll">
        <spinner
            v-if="isLoadLocations"
            :height="'100px'"
            :width="'10px'"
        />
        <div v-else class="rest_list__scroll_container">
            <div v-if="isOperationActiveLocations" class="rest_list__header_scroll">
                <div class="rest_list__header_scroll_switch">
                    <switch_block
                        :key="'switch_block'"
                        :height="24"
                        :width="30"
                        :switchStatus="switchAllStatus"
                        @click_switch="clickSwitchList"
                    />
                </div>
                <div class="rest_list__header_scroll_block" :class="classShowBlockButtons">
                    <button class="rest_list__header_scroll_block_button_enable" @click.prevent="clickEnableSelect">
                        <spinner_button
                            v-if="isProcessOnline"
                            :key="'spinner_button_online_list'"
                            :color="colorSpinnerOnline"
                            :size="'20px'"
                        />
                        <svg v-else>
                            <use xlink:href="/icons/base.svg#icon_play"></use>
                        </svg>
                    </button>
                    <button class="rest_list__header_scroll_block_button_disable" @click.prevent="clickDisableSelect">
                        <spinner_button
                            v-if="isProcessOffline"
                            :key="'spinner_button_offline_list'"
                            :color="colorSpinnerOffline"
                            :size="'20px'"
                        />
                        <svg v-else>
                            <use xlink:href="/icons/base.svg#icon_pause"></use>
                        </svg>
                    </button>
                </div>
            </div>
            <rest_list_item
                v-if="!isLoadLocations"
                v-for="item in locationsList"
                :key="'rest_list_item_' + item.id"
                :restItem="item"
                :operationName="operationName"
                @click_switch_item="clickSwitchItem"
                @click_checkbox_item="clickCheckboxItem"
            />
        </div>
    </div>
    <div v-if="!onlySelectLocations" class="rest_list__buttons">
        <div class="rest_list__buttons_container">
            <button class="rest_list__buttons_button_off" @click.prevent="switchOffAll">
                <div class="rest_list__buttons_button_off_text">
                    {{ __t('O.TURN_OFF_ALL') }}
                </div>
            </button>
            <button class="rest_list__buttons_button_on" @click.prevent="switchOnAll">
                <div class="rest_list__buttons_button_on_text">
                    {{ __t('O.TURN_ON_ALL') }}
                </div>
            </button>
        </div>
    </div>
    <modal
        v-if="statusModal"
        :key="'modal_window_filter'"
    >
        <template v-slot:content>
            <modal_filter
                :key="'modal_filter'"
                @close_filter="closeFilter"
            />
        </template>
    </modal>

</template>

<script>

import rest_list_header_item from "./RestListHeaderItem.vue";
import search_block from "./SearchBlock.vue";
import rest_list_item from "./RestListItem.vue";
import modal from "../modal/Modal.vue";
import modal_filter from "../modal/filter/ModalFilter.vue";
import {changeBody} from "../../mixins/changeBody";
import spinner from "../loader/Spinner.vue";
import switch_block from "./SwitchBlock.vue";
import {createHelpers} from "vuex-map-fields";
import {screenSize} from "../../mixins/screenSize";
import spinner_button from "../loader/SpinnerButton.vue";
import {colorFunctions} from "../../mixins/colorFunctions";
import {mouseMoveScroll} from "../../mixins/mouseMoveScroll";
import rest_list_item_product from "./stop_list/products/RestListItemProduct.vue";

const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})
const {mapFields: mAggregators} = createHelpers({
    getterType: 'aggregators/getAggregatorsField',
    mutationType: 'aggregators/updateAggregatorsField',
})
const {mapFields: mOrders} = createHelpers({
    getterType: 'orders/getOrdersField',
    mutationType: 'orders/updateOrdersField',
})
const {mapFields: mCouriers} = createHelpers({
    getterType: 'couriers/getCouriersField',
    mutationType: 'couriers/updateCouriersField',
})

export default {
    name: "rest_select_list",
    props: {
        operationName: {
            type: String,
            required: true,
        },
        onlySelectLocations: {
            type: Boolean,
            required: true,
        }
    },
    emits: [],
    mixins: [changeBody, screenSize, colorFunctions, mouseMoveScroll],
    components: {
        spinner_button,
        rest_list_header_item,
        search_block,
        rest_list_item,
        modal,
        modal_filter,
        spinner,
        switch_block,
        rest_list_item_product,
    },
    data() {
        return {
            statusModal: false,
            isLoadData: false,
            isLoadLocations: true,
            locationsList: [],
            switchAllStatus: false,
            showBlockButtons: false,
            isProcessOnline: false,
            isProcessOffline: false,
            classScrollElementMouseMove: '.rest_list__header',
            scrollElementMouseMove: null,
            headerList: [],
        }
    },
    beforeMount() {
        EventBus.$on('load_aggregator_locations', this.loadAggregatorLocations);
        EventBus.$on('load_delivery_locations', this.loadDeliveryLocations);
        EventBus.$on('change_active_location', this.changeActiveLocation);
        EventBus.$on('change_active_delivery_location', this.changeActiveDeliveryLocation);
        EventBus.$on('change_location_status_list', this.changeStatusList);
        EventBus.$on('error_data', this.errorData);
    },
    created() {
        if (this.operationName === 'stop_list') {
            this.locationsList = this.posRestaurantsList.filter(item =>{
                if(item.attached_locations && Array.isArray(item.attached_locations)) {
                    return item.attached_locations.some(location => {
                        if(location.id){
                            return this.allSelectLocationsId.includes(parseInt(location.id))
                        }
                    })
                }
            })
            this.isLoadLocations = false;
        } else if(this.operationName === 'active_rest'){
            if (this.activeAggregator.id === 0 && this.aggregatorsList.length !== 0) {
                this.$store.dispatch('aggregators/SET_ACTIVE_AGGREGATOR', this.aggregatorsList[0]);
            }
            this.headerList = this.aggregatorsList;
            const params = {
                user: this.user,
                aggregatorId: this.activeAggregator.id,
                onlySelectLocations: this.onlySelectLocations,
                actionName: 'loadAggregatorLocations'
            }
            this.$store.dispatch('aggregators/AGGREGATOR_LOCATIONS', params);
        } else {
            this.init();
        }
    },
    beforeUnmount() {
        EventBus.$off('load_aggregator_locations', this.loadAggregatorLocations);
        EventBus.$off('load_delivery_locations', this.loadDeliveryLocations);
        EventBus.$off('change_active_location', this.changeActiveLocation);
        EventBus.$off('change_active_delivery_location', this.changeActiveDeliveryLocation);
        EventBus.$off('change_location_status_list', this.changeStatusList);
        EventBus.$off('error_data', this.errorData);
    },
    methods: {
        errorData(actionName) {
            if (actionName === 'loadAggregatorLocations' || actionName === 'loadAggregatorDeliveryLocations') {
                this.locationsList = [];
                this.isLoadLocations = false;
            } else if (actionName === 'isProcessOnline') {
                this.isProcessOnline = false;
            } else if (actionName === 'isProcessOffline') {
                this.isProcessOffline = false;
            }
        },
        init() {
            this.headerList = this.aggregatorsDeliveriesList;
            this.isLoadData = true;
            if (this.aggregatorsDeliveriesList.length === 0) {
                this.$store.dispatch('aggregators/ACTIVE_AGGREGATORS_DELIVERIES_LIST', {
                    user: this.user,
                    onlySelectLocations: this.onlySelectLocations,
                    actionName: 'loadAggregatorDeliveryLocations',
                });
                return;
            }
            if (this.activeAggregator.id === 0) {
                this.$store.dispatch('aggregators/SET_ACTIVE_AGGREGATOR', this.aggregatorsDeliveriesList[0]);
            }
            this.isLoadLocations = true;
            if (this.activeAggregator.type_data === 'aggregator') {
                const params = {
                    user: this.user,
                    aggregatorId: this.activeAggregator.id,
                    onlySelectLocations: this.onlySelectLocations,
                    actionName: 'loadAggregatorLocations'
                }
                this.$store.dispatch('aggregators/AGGREGATOR_LOCATIONS', params);
            } else if (this.activeAggregator.type_data === 'delivery') {
                const params = {
                    user: this.user,
                    deliveryId: this.activeAggregator.id,
                    onlySelectLocations: this.onlySelectLocations,
                    actionName: 'loadDeliveryLocations'
                }
                this.$store.dispatch('couriers/DELIVERY_LOCATIONS', params);
            } else {
                this.errorOutput('O.NOT_FOUND_TYPE_DATA => ' + this.activeAggregator.type_data);
            }
        },
        loadAggregatorLocations() {
            this.locationsList = this.aggregatorLocations;
            this.isLoadLocations = false;
        },
        loadDeliveryLocations() {
            this.locationsList = this.deliveryLocations;
            this.isLoadLocations = false;
        },
        selectItemHeader(itemHeader) {
            this.clickSwitchList(false);
            this.$store.dispatch('aggregators/SET_ACTIVE_AGGREGATOR', itemHeader);
            this.isLoadLocations = true;
            if (this.activeAggregator.type_data === 'aggregator') {
                const params = {
                    user: this.user,
                    aggregatorId: this.activeAggregator.id,
                    onlySelectLocations: this.onlySelectLocations,
                    actionName: 'loadAggregatorLocations'
                }
                this.$store.dispatch('aggregators/AGGREGATOR_LOCATIONS', params);
            } else if (this.activeAggregator.type_data === 'delivery') {
                const params = {
                    deliveryId: this.activeAggregator.id,
                    onlySelectLocations: this.onlySelectLocations,
                    actionName: 'loadDeliveryLocations'
                }
                this.$store.dispatch('couriers/DELIVERY_LOCATIONS', params);
            } else {
                this.errorOutput('O.NOT_FOUND_TYPE_DATA => ' + this.activeAggregator.type_data);
            }
        },
        clickSwitchItem(params) {
            if (this.activeAggregator.type_data === 'aggregator') {
                params.onlySelectLocations = this.onlySelectLocations;
                params.actionName = 'clickSwitchAggregator';
                if (params.state === true) {
                    this.$store.dispatch('aggregators/ADD_ACTIVE_LOCATION', params);
                } else {
                    this.$store.dispatch('aggregators/REMOVE_ACTIVE_LOCATION', params);
                }
            } else if (this.activeAggregator.type_data === 'delivery') {
                params.onlySelectLocations = this.onlySelectLocations;
                params.actionName = 'clickSwitchDelivery';
                if (params.state === true) {
                    this.$store.dispatch('couriers/ADD_ACTIVE_LOCATION', params);
                } else {
                    this.$store.dispatch('couriers/REMOVE_ACTIVE_LOCATION', params);
                }
            } else {
                this.errorOutput('O.NOT_FOUND_TYPE_DATA => ' + this.activeAggregator.type_data);
                return;
            }
        },
        changeActiveLocation() {
            const params = {
                user: this.user,
                aggregatorId: this.activeAggregator.id,
                actionName: 'changeActiveLocation'
            }
            this.$store.dispatch('aggregators/GET_DATA_ACTIVE_LOCATIONS_ID', params);
        },
        changeActiveDeliveryLocation() {
            const params = {
                user: this.user,
                deliveryId: this.activeAggregator.id,
                actionName: 'changeActiveDeliveryLocation'
            }
            this.$store.dispatch('couriers/GET_DATA_ACTIVE_LOCATIONS_ID', params);
        },
        switchOffAll() {
            let restListId = [];
            let dispatchString = ''
            if (this.activeAggregator.type_data === 'aggregator') {
                restListId = this.aggregatorLocations.map(item => item.id);
                dispatchString = 'aggregators/REMOVE_ACTIVE_LOCATION_LIST';
            } else if (this.activeAggregator.type_data === 'delivery') {
                restListId = this.deliveryLocations.map(item => item.id);
                dispatchString = 'couriers/REMOVE_ACTIVE_LOCATION_LIST';
            } else {
                this.errorOutput('O.NOT_FOUND_TYPE_DATA => ' + this.activeAggregator.type_data);
                return;
            }

            const params = {
                user: this.user,
                id: this.activeAggregator.id,
                restList: restListId,
                actionName: 'switchOffAllLocations'
            }
            this.$store.dispatch(dispatchString, params);
        },
        switchOnAll() {
            let restListId = [];
            let dispatchString = ''
            if (this.activeAggregator.type_data === 'aggregator') {
                restListId = this.aggregatorLocations.map(item => item.id);
                dispatchString = 'aggregators/ADD_ACTIVE_LOCATION_LIST';
            } else if (this.activeAggregator.type_data === 'delivery') {
                restListId = this.deliveryLocations.map(item => item.id);
                dispatchString = 'couriers/ADD_ACTIVE_LOCATION_LIST';
            } else {
                this.errorOutput('Not found type_data = ' + this.activeAggregator.type_data);
                return;
            }
            const params = {
                user: this.user,
                id: this.activeAggregator.id,
                restList: restListId,
                actionName: 'switchOnAllLocations'
            }
            this.$store.dispatch(dispatchString, params);
        },
        clickFilter() {
            this.changeBody({class: 'lock'});
            this.statusModal = true;
        },
        closeFilter() {
            this.changeBody({class: ''});
            this.statusModal = false;
        },
        searchInputData(searchData) {
            if (searchData.length < 2 && searchData.length > 0) {
                return;
            }
            this.regTemplate = '(^|\\s)' + searchData;
            let regex = new RegExp(this.regTemplate, 'gi');
            if (this.operationName === 'stop_list') {
                if (searchData === '') {
                    this.locationsList = this.posRestaurantsList;
                    return;
                }
                this.locationsList = this.posRestaurantsList.filter(rest => {
                    regex = new RegExp(this.regTemplate, 'gi');
                    if (rest.address && regex.test(rest.address)) {
                        return true;
                    }
                    regex = new RegExp(this.regTemplate, 'gi');
                    if (rest.title && regex.test(rest.title)) {
                        return true;
                    }
                });
            } else {
                if (searchData === '') {
                    this.locationsList = this.locationsListByType();
                    return;
                }
                this.locationsList = this.locationsListByType.filter(location => {
                    regex = new RegExp(this.regTemplate, 'gi');
                    if (location.linked_restaurant.address && regex.test(location.linked_restaurant.address)) {
                        return true;
                    }
                    regex = new RegExp(this.regTemplate, 'gi');
                    if (location.title && regex.test(location.title)) {
                        return true;
                    }

                });
            }
        },
        clickSwitchList(switchStatus) {
            this.switchAllStatus = switchStatus;
            this.aggregatorLocations.forEach(item => item.isCheck = switchStatus);
            let firstCheck = this.aggregatorLocations.find(item => item.isCheck)
            if (switchStatus && firstCheck !== undefined) {
                this.showBlockButtons = true;
            } else {
                this.showBlockButtons = false;
            }
        },
        clickCheckboxItem(itemList) {
            this.aggregatorLocations.forEach(item => {
                if (item === itemList) {
                    item.isCheck = !item.isCheck;
                }
            })
            if (this.aggregatorLocations.find(item => item.isCheck === true) !== undefined) {
                this.showBlockButtons = true;
                return;
            }
            this.showBlockButtons = false;
        },
        clickEnableSelect() {
            this.isProcessOnline = true;
            this.$store.dispatch('aggregators/CHANGE_LOCATIONS_STATUS_LIST', {
                user: this.user,
                locations: this.locationsCheck,
                status: 'online',
                actionName: 'isProcessOnline',
            })
        },
        clickDisableSelect() {
            this.isProcessOffline = true;
            this.$store.dispatch('aggregators/CHANGE_LOCATIONS_STATUS_LIST', {
                user: this.user,
                locations: this.locationsCheck,
                status: 'offline',
                actionName: 'isProcessOffline',
            })
        },
        changeStatusList(res) {
            if (res.actionName === 'isProcessOnline') {
                this.isProcessOnline = false;
                return;
            }
            if (res.actionName === 'isProcessOffline') {
                this.isProcessOffline = false;
            }
        },
    },
    computed: {
        ...mUser([
            'user',
            'errorMessageUser',
            'isLoadPage'
        ]),
        ...mAggregators([
            'aggregatorsList',
            'aggregatorLocations',
            'activeAggregator',
            'activeAggregatorLocationsId',
            'aggregatorsDeliveriesList',
            'allSelectLocationsId'
        ]),
        ...mOrders([
            'posRestaurantsList',
        ]),
        ...mCouriers([
            'deliveryLocations',
        ]),
        locationsListByType() {
            let result = [];
            if (this.activeAggregator.type_data === 'aggregator') {
                result = this.aggregatorLocations;
            } else if (this.activeAggregator.type_data === 'delivery') {
                result = this.deliveryLocations;
            }
            return result;
        },
        locationsCheck() {
            return this.aggregatorLocations.filter(item => {
                return item.isCheck
            });
        },

        isOperationActiveLocations() {
            if (this.operationName === 'active_rest') {
                return true;
            }
            return false;
        },
        classShowBlockButtons() {
            if (this.showBlockButtons) {
                return 'show';
            }
            return '';
        },
        colorSpinnerOnline() {
            return this.darkerColorHex('#F6673C', 10);
        },
        colorSpinnerOffline() {
            return this.darkerColorHex('#979799', 10);
        },
        showRestHeader() {
            if (this.operationName === 'stop_list') {
                return false;
            }
            return true;
        },
        placeholderTextSearch() {
            if (this.operationName === 'stop_list') {
                return `${this.__t('O.SEARCH_RESTAURANT')}`;
            }
            return `${this.__t('O.SEARCH_LOCATION')}`;
        },
    },
}
</script>
